import { IReviewAndPayPaymentStepModel, ReviewAndPayPaymentStepModel } from "./ReviewAndPayPaymentStep.model";
import { IReviewAndPaySenderInfoStepModel, ReviewAndPaySenderInfoStepModel } from "./ReviewAndPaySenderInfoStep.model";
import { IReviewAndPayWhenToSendStepModel, ReviewAndPayWhenToSendStepModel } from "./ReviewAndPayWhenToSendStep.model";

export interface IReviewAndPaySubpageModel {
    reviewAndPaySenderInfo: IReviewAndPaySenderInfoStepModel;
    reviewAndPayWhenToSend: IReviewAndPayWhenToSendStepModel;
    reviewAndPayPayment: IReviewAndPayPaymentStepModel;
}

export class ReviewAndPaySubpageModel implements IReviewAndPaySubpageModel {
    reviewAndPaySenderInfo: IReviewAndPaySenderInfoStepModel;
    reviewAndPayWhenToSend: IReviewAndPayWhenToSendStepModel;
    reviewAndPayPayment: IReviewAndPayPaymentStepModel;

    constructor() {
        this.reviewAndPaySenderInfo = new ReviewAndPaySenderInfoStepModel();
        this.reviewAndPayWhenToSend = new ReviewAndPayWhenToSendStepModel();
        this.reviewAndPayPayment = new ReviewAndPayPaymentStepModel();
    }

    static isValid(model: IReviewAndPaySubpageModel): boolean {
        return ReviewAndPaySenderInfoStepModel.isValid(model.reviewAndPaySenderInfo, null) &&
            ReviewAndPayWhenToSendStepModel.isValid(model.reviewAndPayWhenToSend) &&
            ReviewAndPayPaymentStepModel.isValid(model.reviewAndPayPayment);
    }
}